import { Link } from '@tanstack/react-router';
import { FileDown, FileUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Can } from '@nucleus-commerce/admin-kit/permissions';
import type { ExportKind } from '@nucleus-commerce/api-client/admin';
import { Button } from '@nucleus-commerce/ui/components/button';

import { isImportKind } from '../schemas/imports-exports-search';

export interface ImportExportLinksProps {
  storeId: string;
  kind: ExportKind;
}

/**
 * List-page toolbar buttons that open the imports and exports page with the kind picked. Kinds
 * that can only be exported (orders, newsletter, gift cards, discount codes) get no Import button.
 */
export function ImportExportLinks({ storeId, kind }: ImportExportLinksProps) {
  const { t } = useTranslation('importsExports');
  return (
    <>
      {isImportKind(kind) ? (
        <Can permission="imports.run">
          <Button asChild variant="outline">
            <Link
              to="/s/$storeId/settings/imports-exports"
              params={{ storeId }}
              search={{ tab: 'imports', new: kind }}
            >
              <FileUp aria-hidden />
              {t('links.import')}
            </Link>
          </Button>
        </Can>
      ) : null}
      <Can permission="exports.run">
        <Button asChild variant="outline">
          <Link
            to="/s/$storeId/settings/imports-exports"
            params={{ storeId }}
            search={{ tab: 'exports', new: kind }}
          >
            <FileDown aria-hidden />
            {t('links.export')}
          </Link>
        </Button>
      </Can>
    </>
  );
}
